<template>
    <div class="border-bottom-0">
        <nav id="bd-docs-nav" class="bd-links d-block" aria-label="Main navigation">
            <div class="logo" v-if="false">
                <center>
                    <img :src="`${publicPath}/img/logo.png`" class="menu-logo" id="menu-logo" alt="menu logo" />
                </center>
            </div>
            <b-skeleton-wrapper :loading="loadingMenu">
                <template #loading>
                    <div class="p-3">
                        <b-skeleton width="100%" height="30px" class="mb-3"></b-skeleton>
                        <b-skeleton width="100%" height="30px" class="mb-3"></b-skeleton>
                        <b-skeleton width="100%" height="30px"></b-skeleton>
                    </div>
                </template>
                <b-link to="/" exact router-tag="div" :class="!isShowSidebar ? 'app-sidebar-inactive' : ''">
                    <b-link :to="{ path : '/home' }" :class="getActiveClass('homeindex')" id="app-link-home"><b-icon-house-door-fill></b-icon-house-door-fill> <span class="menu-text">Home</span></b-link>
                    <b-link v-if="false" :to="{ path : '/inbox' }" :class="getActiveClass('inboxindex')"><b-icon-envelope-fill></b-icon-envelope-fill> My Inbox <b-badge variant="warning" class="float-right" v-if="isShowInboxCount">{{ inboxCount.allInbox }}</b-badge></b-link>
                    <span v-for="(item, parentName, index) in menus" :key="index">
                        <span v-if="getParentInboxExists(item)">
                            <b-link @click="menuClicked" :to="{ path : item[0].uri }" :class="getActiveClass(item[0].uri + 'index')"><b-icon :icon="subMenuIcons[item[0].name]"></b-icon>
                                <span class="menu-text">
                                    <app-long-text :showPopover="true" class="menu-name-text" :id="'menu-name-' + index" :maxLength="1000" :mdMaxLength="1000" :text="(item[0].name) ? item[0].name : ''" />
                                </span>
                                <b-badge variant="warning" :class="'float-right ' + (getParentInboxCount(parentName) <= 1 ? 'menu-notification-one ' : (getParentInboxCount(parentName) >= 1 && getParentInboxCount(parentName) <= 9 ? 'menu-notification ' : (getParentInboxCount(parentName) >= 99 ? 'menu-notification-three ' : 'menu-notification-two ')))" v-if="isShowInboxCount">{{ getParentInboxCount(parentName) }}</b-badge>
                            </b-link>
                        </span>
                        <span v-else>
                            <b-button @click="parentMenuClicked" class="bd-toc-link" block href="#" v-b-toggle="'menu-accordion-' + index"><b-icon :icon="menuIcons[parentName]"></b-icon>
                                <span class="menu-text">
                                    <app-long-text class="menu-parent-name-text" :id="'menu-parent-name-' + index" :maxLength="1000" :mdMaxLength="1000" :text="(parentName) ? parentName : ''" />
                                </span>
                                <span class="menu-arrow">
                                    <b-icon-chevron-right class="float-right chevron-right"></b-icon-chevron-right><b-icon-chevron-down class="float-right chevron-down"></b-icon-chevron-down>
                                </span>
                                <b-badge variant="warning" class="float-right mr-2 mt-1" v-if="isShowInboxCount">{{ getParentInboxCount(parentName) }}</b-badge>
                            </b-button>
                            <b-collapse :id="'menu-accordion-' + index" :visible="getVisibility(item)" accordion="menu-accordion" role="tabpanel" class="menu-accordion">
                                <span v-for="(itemMenu, indexChild) in item" :key="itemMenu.id">
                                    <b-link @click="menuClicked" :to="{ path : itemMenu.uri }" :class="getActiveClass(itemMenu.uri + 'index')"><b-icon :icon="subMenuIcons[itemMenu.name]"></b-icon> 
                                        <app-long-text class="menu-child-name-text" :id="'menu-child-name-' + itemMenu.id + '-' + indexChild" :maxLength="1000" :mdMaxLength="1000" :text="(itemMenu.name) ? itemMenu.name : ''" />
                                    <b-badge variant="warning" class="float-right" v-if="isShowInboxCount">{{ getItemInboxCount(itemMenu.id) }}</b-badge></b-link>
                                </span>
                            </b-collapse>
                        </span>
                    </span>
                </b-link>
            </b-skeleton-wrapper>
        </nav>
        <Portal to="sidebar-search">
            <b-input-group class="sidebar-search-input w-auto">
                <b-form-input placeholder="Search Menu" v-model="searchMenu"></b-form-input>
                <b-input-group-append>
                    <b-button class="btn-default" size="sm"><b-icon-search class="mr-1"></b-icon-search></b-button>
                </b-input-group-append>
            </b-input-group>
        </Portal>
    </div>
</template>
<style scoped lang="scss">
.menu-logo {
    width: 120px;
    margin-bottom: 20px;
}
@media (max-width: 1366px) {
    .menu-logo {
        width: 100px;
        margin-bottom: 20px;
    }
}
@media (max-width: 500px) {
    .menu-logo {
        width: 80px;
        margin-bottom: 20px;
    }
}

.container-app-inactive {
        
        .menu-logo {
            opacity: 0;
        }
    }

.active, a.router-link-exact-active {
    background-color: #ffd599;
    color: #ffd599;
    /*border: 1px solid var(--main-border-color);*/
    border-radius: 15px;
}

.active:hover, a.router-link-exact-active:hover {
    color: var(--primary-font-color) !important;
}

.btn {
    background-color: transparent;
    border: none;
    border-radius: 10;
    text-align: justify;
    font-weight: 400 !important;
    font-size: 14px !important;
}

.bd-toc-link:hover {
    border-radius: 15px;
}

#bd-docs-nav {
    .btn:hover, .btn.not-collapsed, .btn-secondary:active {
        background-color: #1b1b28 !important;
        color: #fff !important;
        border-radius: 15px;
    }
}

.btn.not-collapsed .chevron-down {
    display: inline;
}

.btn-secondary:active:focus {
    box-shadow: none;
}

.btn.not-collapsed .chevron-right {
    display: none;
}

.btn.collapsed .chevron-right {
    display: inline;
}

.btn.collapsed .chevron-down {
    display: none;
}

.menu-arrow {
    font-size: 10px;
    margin-top: 3px;
    display: inline-block;
    float: right;
}

#bd-docs-nav .btn {
    border-radius: var(--sidebar-button-radius) !important;
}

a {
    margin-top: 4px;
    margin-bottom: 4px;
}

@media(min-width:1331px){ 
    ::v-deep .menu-text .menu-name-text span, ::v-deep .menu-child-name-text span{
        text-wrap: nowrap;
        width: 70%;
        display: inline-block;
        overflow-x: clip;
    }
}

@media(max-width:1330px){ 
    ::v-deep .menu-text .menu-name-text span, ::v-deep .menu-child-name-text span{
        text-wrap: nowrap;
        width: 80%;
        display: inline-block;
        overflow-x: clip;
    }

    @keyframes marquee {
        0% { left: 0; }
        100% { left: -100%; }
    }
}
</style>
<script>
import RoleDetail from '@/models/Core/RoleDetail';
import { mapState } from 'vuex';

export default {
    props: 
        {
            isShowSidebar : {
                type: Boolean,
            },
        },
    data() {
        return {
            activeClass:"",
            activeElement: "",
            menus : {},
            menuIcons : {},
            subMenuIcons : {},
            tempMenus : {},
            tempMenuIcons : {},
            tempSubMenuIcons : {},
            loadingMenu: false,
            isShowSidebarInput: false,
            roleDetails : [],
            inboxCount: 0,
            isShowInboxCount: true,
            show: false,
            expandedAccordionId: '',
            searchMenu: '',
        }
    },
    methods : {
        getItemInboxCount(functionId) {
            if (this.inboxCount != null && this.inboxCount != undefined) {
                if (functionId.indexOf("approval") > -1) {
                    let functionApproval = functionId.replace("_need_approval", "");
                    functionApproval = functionId.replace("_approval", "")
                    if (this.inboxCount.inboxes) {
                        let result = this.inboxCount.inboxes.filter(item => item.functionId == functionApproval)
                        if (result) {
                            if (result[0])
                                return result[0].needApproval;
                        }
                            
                    }
                }
                if (functionId.indexOf("revision") > -1) {
                    let functionRevision = functionId.replace("_need_revision", "");
                    functionRevision = functionRevision.replace("_revision", "");
                    if (this.inboxCount.inboxes) {
                        let result = this.inboxCount.inboxes.filter(item => item.functionId == functionRevision)
                        if (result) {
                            if (result[0])
                                return result[0].needRevision;
                        }
                    }
                }
            }
        },
        getParentInboxExists(data) {
            var result = false;
            data.forEach((item) => {
                if (item.isApproval) {
                    result = true;
                }
            });
            return result;
            /*let parentId = parentName.split(" ").join("_").toLowerCase();
            if (this.inboxCount != null && this.inboxCount != undefined) {
                let inboxCount = 0;
                let isExists = false;
                if (this.inboxCount.inboxes) {
                    let result = this.inboxCount.inboxes.filter(item => item.functionId == parentId)
                    //console.log(result);
                    if (result) {
                        if (result[0]) {
                            isExists = true;
                            inboxCount += result[0].needApproval;
                        }
                    }
                        
                }
            
                if (this.inboxCount.inboxes) {
                    let result = this.inboxCount.inboxes.filter(item => item.functionId == parentId)
                    //console.log(result);
                    if (result) {
                        if (result[0]) {
                            isExists = true;
                            inboxCount += result[0].needRevision;
                        }
                    }
                }

                if (isExists)
                    return true;
            }*/
        },
        getParentInboxCount(parentName) {
            let parentId = parentName.split(" ").join("_").toLowerCase();
            //console.log(parentId);
            
            if (this.inboxCount != null && this.inboxCount != undefined) {
                let inboxCount = 0;
                let isExists = false;
                if (this.inboxCount.inboxes) {
                    let result = this.inboxCount.inboxes.filter(item => item.functionId == parentId)
                    //console.log(result);
                    if (result) {
                        if (result[0]) {
                            isExists = true;
                            inboxCount += result[0].needApproval;
                        }
                    }
                        
                }
            
                if (this.inboxCount.inboxes) {
                    let result = this.inboxCount.inboxes.filter(item => item.functionId == parentId)
                    //console.log(result);
                    if (result) {
                        if (result[0]) {
                            isExists = true;
                            inboxCount += result[0].needRevision;
                        }
                    }
                }

                if (isExists)
                    return inboxCount > 99 ? '99+' : inboxCount;
            }
        },
        getInboxDetails() {
            //this.isShowInboxCount = false;
            this.$http.get(process.env.VUE_APP_API_URL +'home/inboxcount').then(result => {
                //this.isShowInboxCount = true;
                this.inboxCount = result.data;
            });
        },
        menuClicked() {
            let windowWidth = window.innerWidth;
            if (windowWidth <= 1330) {
                this.$emit('update:isShowSidebar', this.isShowSidebarInput);
            }
        },
        parentMenuClicked() {
            if (!this.isShowSidebar) {
                this.$emit('update:isShowSidebar', true);
            }
        },
       getActiveClass(text) {
           var isActive = false;
           text = text.replace(/[\/]/, "");
           text = text.replace(/[\/]/, "");
           //console.log(text);
           var menu_name = this.$route.name;
           //console.log(menu_name);
           if (Array.isArray(text)) {
               text.forEach(item => { 
                if (menu_name != null) {
                    if (menu_name.indexOf(item) == 0 && text.length == menu_name.length) {
                        isActive = true;
                    } else {
                        text = text.replace("index","");
                        if (menu_name.indexOf(item) == 0 && text.length == menu_name.length) {
                            isActive = true;
                        }
                    }
                }
               });  
           } else {
               if (menu_name != null) {
                   if (menu_name.indexOf(text) == 0 && text.length == menu_name.length) {
                        isActive = true;
                    } else {
                        text = text.replace("index","");
                        if (menu_name.indexOf(text) == 0 && text.length == menu_name.length) {
                            isActive = true;
                        }
                    }

               }
           }
            if (isActive) {
                this.activeClass = text;
                return "bd-toc-link active";
            }
            return "bd-toc-link";
        },
        getMenu() {
            this.loadingMenu = true;
            this.roleDetails = RoleDetail.query().with("functionInfo").with("functionInfo.moduleInfo").orderBy("orderPosition").get();
            let menus = {};
            let menuIcons = {};
            let subMenuIcons = {};
            let subMenuInboxCount = {};
            if (this.roleDetails != null && this.roleDetails.length > 0) {
                let defaultMenu = {
                    icon : "people-fill",
                    name : "Master Data"
                };
                let subMenuIconDefault = "circle-fill";
                //menus[defaultMenu.name] = Array();
                //menuIcons[defaultMenu.name] = defaultMenu.icon;
                this.roleDetails.forEach(item => {
                    if (item != null) {
                        if (item.functionInfo != null) {
                            if (item.showInMenu) {
                                let moduleInfo = item.functionInfo.moduleInfo;
                                if (moduleInfo != null) {
                                    //console.log(item.moduleName + ' - ' + item.functionName);
                                    if (!menus[moduleInfo.name]) {
                                        menus[moduleInfo.name] = Array();
                                    }
                                    menus[moduleInfo.name].push(item.functionInfo);
                                    if(!menuIcons[moduleInfo.name]){
                                        menuIcons[moduleInfo.name] = defaultMenu.icon;
                                    }
                                    menuIcons[moduleInfo.name] = (moduleInfo.iconName?moduleInfo.iconName:defaultMenu.icon);
                                    if(!subMenuIcons[item.functionInfo.name]){
                                        subMenuIcons[item.functionInfo.name] = subMenuIconDefault;
                                    }
                                    subMenuIcons[item.functionInfo.name] = (item.functionInfo.iconName?item.functionInfo.iconName:subMenuIconDefault);
                                } else {
                                    //menus[defaultMenu].push(item.functionInfo);
                                }
                            }
                        }
                    }
                });
            }
            
            this.menus = menus;
            this.menuIcons = menuIcons;
            this.subMenuIcons = subMenuIcons;
            this.loadingMenu = false;
        },
        searchMenuFromRole(newValue) {
            this.loadingMenu = true;
            let roleDetails = this.roleDetails.filter(role => role.functionInfo.name.toLowerCase().includes(newValue.toLowerCase()));

            let menus = {};
            let menuIcons = {};
            let subMenuIcons = {};
            let subMenuInboxCount = {};
            if (roleDetails != null && roleDetails.length > 0) {
                let defaultMenu = {
                    icon : "people-fill",
                    name : "Master Data"
                };
                let subMenuIconDefault = "circle-fill";
                roleDetails.forEach(item => {
                    if (item != null) {
                        if (item.functionInfo != null) {
                            if (item.showInMenu) {
                                let moduleInfo = item.functionInfo.moduleInfo;
                                if (moduleInfo != null) {
                                    //console.log(item.moduleName + ' - ' + item.functionName);
                                    if (!menus[moduleInfo.name]) {
                                        menus[moduleInfo.name] = Array();
                                    }
                                    menus[moduleInfo.name].push(item.functionInfo);
                                    if(!menuIcons[moduleInfo.name]){
                                        menuIcons[moduleInfo.name] = defaultMenu.icon;
                                    }
                                    menuIcons[moduleInfo.name] = (moduleInfo.iconName?moduleInfo.iconName:defaultMenu.icon);
                                    if(!subMenuIcons[item.functionInfo.name]){
                                        subMenuIcons[item.functionInfo.name] = subMenuIconDefault;
                                    }
                                    subMenuIcons[item.functionInfo.name] = (item.functionInfo.iconName?item.functionInfo.iconName:subMenuIconDefault);
                                } else {
                                    //menus[defaultMenu].push(item.functionInfo);
                                }
                            }
                        }
                    }
                });
            }
            
            this.menus = menus;
            this.menuIcons = menuIcons;
            this.subMenuIcons = subMenuIcons;
            this.loadingMenu = false;
        },
        getVisibility(menus) {
            let isVisible = false;
            var menu_name = this.$route.name;
            menus.forEach(item => {
                let text = item.uri
                text = text.replace('/[/]/', "");
                text = text.replace('/[/]/', "");
                text = text + "index";
                if (menu_name != null) {
                    if (menu_name.indexOf(text) == 0 && text.length == menu_name.length) {
                        isVisible = true;
                    }
                } else {
                    text = text.replace("index","");
                    if (menu_name.indexOf(text) == 0 && text.length == menu_name.length) {
                        isVisible = true;
                    }
                }
            });
            return isVisible;
        }
    },
    watch : {
        activeClass : function(val) {
            if (document.getElementById(val) != null) {
               this.activeElement = document.getElementById(val).parentElement.id;
            }
        },
        isRoleLoaded(newValue, oldValue) {
            this.getMenu();
        },
        '$route'(to, from) {
            if (to) {
                if (to.name != null && to.name != undefined) {
                    if (to.name.indexOf("index") > -1) {
                        this.getInboxDetails();
                    }
                }
                this.searchMenu = "";
            }
        },
        isShowSidebar(newValue, oldValue) {
            if (!newValue) {
                if (this.expandedAccordionId != "" && this.expandedAccordionId != null)
                    this.$root.$emit('bv::toggle::collapse', this.expandedAccordionId);
                this.expandedAccordionId="";
            }
        },
        searchMenu(newValue, oldValue) {
            if (newValue != null && newValue != "") {
                let prevMenu = JSON.parse(JSON.stringify(this.menus));
                let prevMenuIcons = JSON.parse(JSON.stringify(this.menuIcons));
                let prevSubMenuIcons = JSON.parse(JSON.stringify(this.subMenuIcons));
                if (oldValue != null && oldValue != "") {
                    prevMenu = JSON.parse(JSON.stringify(this.tempMenus));
                    prevMenuIcons = JSON.parse(JSON.stringify(this.tempMenuIcons));
                    prevSubMenuIcons = JSON.parse(JSON.stringify(this.tempSubMenuIcons));
                }
                this.tempMenus = prevMenu;
                this.tempMenuIcons = prevMenuIcons;
                this.tempSubMenuIcons = prevSubMenuIcons;
                
                this.searchMenuFromRole(newValue);
            } else {
                this.menus = this.tempMenus;
                this.menuIcons = this.tempMenuIcons;
                this.subMenuIcons = this.tempSubMenuIcons;
            }
        },
        inboxCounter : {
            handler(newValue) {
                this.inboxCount = newValue;
                this.$forceUpdate();
            },
            deep: true
        },
    },
    async mounted() {
        this.getInboxDetails();
        this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
            if (isJustShown) {
                if (this.expandedAccordionId != collapseId)
                    this.expandedAccordionId = collapseId;
                else
                    this.expandedAccordionId = "";
            } else {
                this.expandedAccordionId = "";
            }

        });
        await this.getMenu();
    },
    computed : {
        isRoleLoaded() {
            this.getMenu();
            return this.$store.state.isRoleLoaded;
        },
        ...mapState({
			inboxCounter: state => state.inbox.inboxCounter,
		})
    }
}
</script>